import React from "react";
import debounce from "lodash/debounce";
import styled, { css } from "styled-components";
import { Select, Typography, Empty, Spin } from "antd";
import { Controller } from "react-hook-form";
import { InputContainer, StyledTitle } from "pages/jobs/add";

import useClientData from "hooks/api/client/useClientData";
import _ from "lodash";

const formatData = (resData) => {
  const newData = resData?.map((d) => ({
    key: d.id,
    value: d.id,
    text: d.name,
  }));

  return newData;
};

const ClientSelect = (props) => {
  const { control, setValue, errors, trigger } = props;
  const [clientKeyword, setClientKeyword] = React.useState("");
  const { data: clientData, status: clientDataStatus } = useClientData(
    clientKeyword !== "" && {
      keyword: clientKeyword,
    }
  );

  const searchClientByKeyword = (keyword) => {
    setClientKeyword(keyword);
  };

  return (
    <>
      <InputContainer>
        <StyledTitle>Client</StyledTitle>
        <>
          <Controller
            name="client_id"
            control={control}
            render={({ onChange, onBlur, value }) => {
              return (
                <StyledSelect
                  showSearch
                  placeholder="Assign client"
                  value={value}
                  filterOption={false}
                  error={_.get(errors, "client_id")}
                  onSearch={debounce(searchClientByKeyword, 800)}
                  notFoundContent={
                    clientDataStatus === "loading" ? (
                      <Spin size="small" />
                    ) : (
                      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                    )
                  }
                  onChange={(e) => {
                    setValue("client_id", e, {
                      shouldDirty: true,
                    });
                    trigger("client_id");
                  }}
                  style={{ width: "100%" }}
                >
                  {formatData(clientData)?.map((d) => (
                    <Select.Option key={d.value}>{d.text}</Select.Option>
                  ))}
                </StyledSelect>
              );
            }}
          />
        </>

        {errors && _.get(errors, "client_id") && (
          <StyledError>
            <p>{errors && _.get(errors, "client_id").message}</p>
          </StyledError>
        )}
      </InputContainer>
    </>
  );
};

const StyledError = styled.span`
  color: ${(props) => props.theme.colors.red[600]};
  padding: 0;
  margin: 0;

  p {
    font-size: 0.8rem;
    margin: 0;
  }
`;

const StyledSelect = styled(Select)`
  ${(props) =>
    props.error &&
    css`
      .ant-select-selector {
        border-color: ${(props) => props.theme.colors.red[600]} !important;
      }
    `};
`;

export default ClientSelect;
